import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import * as shortlistActions from '../../actions/shortlist';
import { isCommonFilterDisabled } from '../../helpers/catalogueUtils';
import { shortlistStateKey } from '../../helpers/shortlistUtils';

class LotsFound extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            lotNo: props.refinement.lotNo
        };

        this.upcoming = props.upcoming;

        this.handleLotNoChange = this.handleLotNoChange.bind(this);
        this.triggerLotNoChangeHandlerDebounced = debounce(
            this.triggerLotNoChangeHandler.bind(this),
            500
        );
        this.handleOnlyWithEntriesChange = this.handleOnlyWithEntriesChange.bind(this);
        this.handleOnlySoldChange = this.handleOnlySoldChange.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this);
    }

    componentWillReceiveProps({ refinement: { lotNo } }) {
        if (this.state.lotNo !== lotNo) {
            this.setState({ lotNo });
        }
    }

    triggerLotNoChangeHandler(lotNo) {
        this.props.applySearchLotNoFilter(lotNo);
    }

    handleLotNoChange(e) {
        const lotNo = Number.parseInt(e.target.value, 10) || null;

        if (this.state.lotNo === lotNo) {
            return false;
        }

        this.setState({ lotNo });
        this.triggerLotNoChangeHandlerDebounced(lotNo);

        return true;
    }

    handleOnlyWithEntriesChange(e) {
        this.props.applyShortlistEnteredFilter(e.target.checked);
    }

    handleOnlySoldChange(e) {
        this.props.applyShortlistSoldFilter(e.target.checked);
    }

    handleNotesChange(e) {
        this.props.applyShortlistNotesFilter(e.target.checked);
    }

    isCommonFilterDisabled() {
        return isCommonFilterDisabled(this.props.refinement);
    }

    /**
     * @callback handleChangeCallback
     * @param e
     */

    /**
     * Method used for rendering checkbox
     * @param {string} id
     * @param {string} label
     * @param {boolean} checked - Indicates whether checkbox is checked or not.
     * @param {handleChangeCallback} handleChange
     */
    renderCheckbox(id, label, checked, handleChange) {
        return (
            <div className="sales__catalogueRefineLotsEntriesWrp">
                <label htmlFor={id} className="checkbox_holder">
                    <input
                        type="checkbox"
                        id={id}
                        disabled={this.isCommonFilterDisabled()}
                        checked={checked}
                        onChange={handleChange}
                        className="ui-checkbox_input"
                    />
                    <span className="ui-checkbox" />
                    <span>{label}</span>
                </label>
            </div>
        );
    }

    renderSoldCheckbox() {
        return this.renderCheckbox(
            'sold_only',
            'Sold',
            this.props.refinement.price,
            this.handleOnlySoldChange
        );
    }

    renderWithEntriesCheckbox() {
        return this.renderCheckbox(
            'with_entries',
            'With entries',
            this.props.refinement.entered,
            this.handleOnlyWithEntriesChange
        );
    }

    renderWithNotesCheckbox() {
        return this.renderCheckbox(
            'with_notes',
            'With notes',
            this.props.refinement.withNotes,
            this.handleNotesChange
        );
    }

    render() {
        const { lotsFound } = this.props;
        return (
            <div className="sales__catalogueRefineLotsWrp">
                <div className="sales__catalogueRefineLotsNumWrp">
                    <span>Total shortlist</span>
                    <span
                        data-test-selector="lots_found_right_block"
                        className={classNames('sales__catalogueRefineLotsNumFound', {
                            sales__catalogueRefine_smLots: lotsFound.toString().length === 4,
                            sales__catalogueRefine_exSmLots: lotsFound.toString().length > 4,
                        })}
                    >
                        {lotsFound}
                    </span>
                </div>
                <div className="sales__catalogueRefineLotsLabel">
                    <span>Show only lots:</span>
                </div>
                {this.renderSoldCheckbox()}
                {this.renderWithEntriesCheckbox()}
                {this.renderWithNotesCheckbox()}
            </div>
        );
    }
}

LotsFound.propTypes = {
    refinement: PropTypes.shape({
        lotNo: PropTypes.number,
        entered: PropTypes.bool,
        price: PropTypes.bool,
    }).isRequired,

    lotsFound: PropTypes.number.isRequired,

    applyShortlistNotesFilter: PropTypes.func.isRequired,
    applyShortlistEnteredFilter: PropTypes.func.isRequired,
    applyShortlistSoldFilter: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    const { data: { lotsFound }, refinement } = state[shortlistStateKey];
    return {
        refinement,
        lotsFound
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(shortlistActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LotsFound);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/LotsFound.js